import {infraEquipmentCondition} from "@/components/mixins/InfraEquipmentMixin.js";

export const mixedWasteBinHelper = {
    methods: {
        getMixedWasteBinWasteType: function (){
            return [
                {name: this.$t('mixed_waste_bins.waste_type_biological'), value: mixedWastBinWasteType.BIOLOGICAL},
                {name: this.$t('mixed_waste_bins.waste_type_drug_syringe_container'), value: mixedWastBinWasteType.DRUG_SYRINGE_CONTAINER},
                {name: this.$t('mixed_waste_bins.waste_type_waste_container'), value: mixedWastBinWasteType.WASTE_CONTAINER},
                {name: this.$t('mixed_waste_bins.waste_type_dog_litter_box'), value: mixedWastBinWasteType.DOG_LITTER_BOX},
                {name: this.$t('mixed_waste_bins.waste_type_with_ashtray'), value: mixedWastBinWasteType.TRASH_CAN_WITH_ASHTRAY},
                {name: this.$t('mixed_waste_bins.waste_type_trash_can'), value: mixedWastBinWasteType.TRASH_CAN},
                {name: this.$t('mixed_waste_bins.waste_type_bag_dispenser'), value: mixedWastBinWasteType.GARBAGE_BAG_DISPENSER},
                {name: this.$t('mixed_waste_bins.waste_type_ashtray'), value: mixedWastBinWasteType.ASHTRAY},
                {name: this.$t('mixed_waste_bins.waste_type_other'), value: mixedWastBinWasteType.OTHER},
                {name: this.$t('mixed_waste_bins.waste_type_unknown'), value: mixedWastBinWasteType.UNKNOWN},
            ]
        },
        getMixedWasteBinInterval: function (){
            return [
                {name: this.$t('mixed_waste_bins.interval_daily'), value: mixedWasteBinInterval.DAILY},
                {name: this.$t('mixed_waste_bins.interval_once_week'), value: mixedWasteBinInterval.ONCE_WEEK},
                {name: this.$t('mixed_waste_bins.interval_every_two_weeks'), value: mixedWasteBinInterval.EVERY_TWO_WEEKS},
                {name: this.$t('mixed_waste_bins.interval_other'), value: mixedWasteBinInterval.OTHER},
                {name: this.$t('mixed_waste_bins.interval_not_specified'), value: mixedWasteBinInterval.NOT_SPECIFIED},
            ]
        }
    }
}
    export const mixedWastBinWasteType = {
        BIOLOGICAL: 1,
        DRUG_SYRINGE_CONTAINER: 2,
        WASTE_CONTAINER: 3,
        DOG_LITTER_BOX: 4,
        TRASH_CAN_WITH_ASHTRAY: 5,
        TRASH_CAN: 6,
        GARBAGE_BAG_DISPENSER: 7,
        ASHTRAY: 8,
        OTHER: 9,
        UNKNOWN: 10
    }

    export const mixedWasteBinInterval = {
        DAILY: 1,
        ONCE_WEEK: 2,
        EVERY_TWO_WEEKS: 3,
        OTHER: 4,
        NOT_SPECIFIED: 5
    }



